import React, { useState } from "react";
// Use Forms
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
// React Bootstrap
import { Form, Button, Col } from "react-bootstrap";
// Utils
import { vinculacionCon } from "../../../contexto";

const FormVinculacion = ({ defaultValues, submissionHandler }) => {
  const [validated] = useState(false);
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
  });

  // On submit del formulario
  const onSubmit = (data) => {
    submissionHandler(data);
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
      <Form.Row>
        <small className="mb-3">
          Los campos con un <b>*</b> deben de ser rellenados.
        </small>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} xs={12} md controlId="descriptionVinculacion-comunidad">
          <Form.Label>{"Descripción *"}</Form.Label>
          <Form.Control
            name="description"
            placeholder={"Texto"}
            type="text"
            isInvalid={errors?.name}
            {...register("description", {
              required: "Este campo es obligatorio",
              maxLength: {
                value: 300,
                message: "El máximo de caracteres es 300",
              },
            })}
          />
          <ErrorMessage errors={errors} name="name" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>

        <Form.Group as={Col} xs={12} md controlId="vinculacionCon-comunidad">
          <Form.Label>{"Vinculación Con *"}</Form.Label>
          <Form.Control name="type" as="select" custom isInvalid={errors.type} {...register("type", {})}>
            {vinculacionCon &&
              Object.keys(vinculacionCon).map((vinculacionConKey) => (
                <option key={vinculacionConKey} value={vinculacionConKey}>
                  {vinculacionCon[vinculacionConKey]}
                </option>
              ))}
          </Form.Control>
        </Form.Group>
      </Form.Row>

      <Form.Group>
        <Button type="submit" variant="outline-primary" className="btn btn-block mt-5">
          Guardar
        </Button>
      </Form.Group>
    </Form>
  );
};

export default FormVinculacion;
